<!--
首页栏目标题

使用说明：

<Title
 :text="'标题内容'"
 />

-->

<template>
    <div class="wrap">
        
        <div class="text">{{text}}</div>

    </div>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style lang="less" scoped>

.wrap{

}

.text{
    display: block;
    width: 60vw;
    margin: 5vw auto;
    font-size: 3.73vw;
    font-weight: bold;
    text-align: center;
    color: #3c3c3c;

    &:before,
    &:after{
        content: '';
        display: inline-block;
        background: #d1d1dd;
        width: 2.66vw;
        height: 2.66vw;
        border-radius: 50%;
        margin: 0 3.46vw;
    }
}

</style>





// WEBPACK FOOTER //
// src/components/homepage/Title.vue